const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';
// import Timer from "react-compound-timer";
import { createTimeModel, useTimeModel } from "react-compound-timer";

//Import Designs
import { Typography, Grid2 } from '@mui/material';
import { addHours } from 'date-fns';
import dateFormat from 'dateformat';

const Timer = ({ timer, ...props }) => {
    const { value } = useTimeModel(timer);
    const { t, label_timer, votes_timertextcolor, votes_counter_font_size } = props;
    return (<Grid2 container>
        <Typography variant="body1" className="timer_typography" style={{ 'color': votes_timertextcolor, fontSize: votes_counter_font_size + 'px' }}>{t(label_timer)}</Typography>
        <Typography variant="body1" className="timer_typography" style={{ 'color': votes_timertextcolor, fontSize: votes_counter_font_size + 'px' }}>{value.d} {t('days')}</Typography>
        <Typography variant="body1" className="timer_typography" style={{ 'color': votes_timertextcolor, fontSize: votes_counter_font_size + 'px' }}>{value.h} {t('hours')}</Typography>
        <Typography variant="body1" className="timer_typography" style={{ 'color': votes_timertextcolor, fontSize: votes_counter_font_size + 'px' }}>{value.m} {t('minutes')}</Typography>
        <Typography variant="body1" className="timer_typography" style={{ 'color': votes_timertextcolor, fontSize: votes_counter_font_size + 'px' }}>{value.s} {t('seconds')}</Typography>
    </Grid2>);
}

class Votingtimer extends Component {
    constructor(props) {
        super(props);
        this.state = { anchorEl: '', open: '' };
    }

    calculateVoteTimeLeft(start_time, pause_voting_hours = 0) {
        let current_date = this.props.currentdate;
        if (!current_date) {
            current_date = new Date();
        }
        if (start_time) {
            start_time = start_time.replace(/ /g, "T");
            // var dateFormat = require("dateformat");
            var start_Date = dateFormat(start_time);
            let difference = addHours(new Date(start_Date), pause_voting_hours) - current_date;
            return difference;
        }
        return -1;
    }

    render() {
        const { t } = this.props;
        const { votes_timerbgcolor, votes_timertextcolor, votes_counter_font_size } = this.props;

        let end_time = this.props.short.end_time;
        let start_time = this.props.short.start_time;

        let timer = this.calculateVoteTimeLeft(start_time, this.props.short.pause_voting);
        let label_timer = 'vote_starts_in';
        if (timer < 0) {
            if (end_time) {
                timer = this.calculateVoteTimeLeft(end_time);
                label_timer = 'vote_ends_in';
            }
            else {
                timer = 0
            }
        }

        let pagin_val_prop = (typeof this.props.pagin_val !== "undefined") ? this.props.pagin_val : null;
        let total_posts = pagin_val_prop != null ? pagin_val_prop.total_posts : 0;
        let tax_activationcount = this.props.short.allcatoption.tax_activationcount;
        if (tax_activationcount !== null && tax_activationcount !== 0 && tax_activationcount !== undefined && tax_activationcount !== "" && parseInt(tax_activationcount) <= parseInt(total_posts) && end_time) {
            label_timer = 'vote_ends_in';
            timer = this.calculateVoteTimeLeft(end_time)
        }

        if (timer > 0) {

            const value = createTimeModel({
                initialTime: timer,
                direction: "backward",
            });

            return (
                <Grid2 className="wpvc_counter_timer" style={{ backgroundColor: votes_timerbgcolor }} >
                    <div key={timer}>
                        <Timer {...this.props} timer={value} label_timer={label_timer}></Timer>
                        {/* <Timer initialTime={timer} direction="backward">
                        {() => ( */}

                        {/* )}
                    </Timer> */}
                    </div>
                </Grid2>
            )
        } if (timer < 0) {
            return <Typography variant="body1" className="timer_typography" style={{ 'color': votes_timertextcolor, fontSize: votes_counter_font_size + 'px' }}>{t('vote_ended')}</Typography>
        } else {
            return ''
        }
    }
}

export default connect()(withTranslation("translations")(Votingtimer));
